<div class="not-found">
    <section class="not-found-description">
        <h1>¡Oops!</h1>
        <h3>La página que buscas no se encuentra.</h3>
        <p>Es posible que el link esté mal escrito o la página haya sido movida a otra sección.</p>
        <a class="btn btn-primary" href="/panel">Regresar al inicio</a>
    </section>
    <img src="assets/images/not-found.svg" alt="Página no encontrada" />
</div>